import React from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import useQuestionsQueryParams from '../../hooks/useQuestionsQueryParams';
import { questionsQueryKeys } from '../../queries/questionsQueryKeys';
import { selectedQuestionSelector } from '../../store/selectors';
import { setSelectedQuestion } from '../../store/actions';
import CloseQuestionBtn from '../CloseQuestionBtn/CloseQuestionBtn';
import { questionCloseStateId } from '../../constants/common';
import useForceCloseQuestionMutation from '../../mutations/useForceCloseQuestionMutation';

const ForceCloseQuestion = ({ tooltipTitle, disabled }) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const questionsQueryParams = useQuestionsQueryParams();

  const selectedQuestion = useSelector(selectedQuestionSelector);

  const handleSuccess = (data) => {
    if (data !== 'Error') {
      queryClient.invalidateQueries(
        questionsQueryKeys.questions(questionsQueryParams)
      );

      dispatch(
        setSelectedQuestion({
          ...selectedQuestion,
          stateId: questionCloseStateId,
          stateName: 'Закрыт',
        })
      );
    }
  };

  const { mutate: closeQuestion, isLoading: isCloseQuestionLoading } =
    useForceCloseQuestionMutation({
      onSuccess: handleSuccess,
    });

  const handleConfirm = () => {
    closeQuestion({ questionId: selectedQuestion.id });
  };

  return (
    <CloseQuestionBtn
      tooltipProps={{
        title: tooltipTitle,
        placement: 'bottom',
      }}
      popconfirmTitle="Закрыть вопрос без подтверждения собственника?"
      onConfirm={handleConfirm}
      loading={isCloseQuestionLoading}
      disabled={disabled}
    />
  );
};

export default ForceCloseQuestion;
